<template>
    <h2 class="content-block">{{ tela.text }}</h2>
    <div class="box">
        <DxForm :form-data="formData" class="box">
            <DxGroupItem :col-count="tela.quant" css-class="form-group">
                <DxSimpleItem v-for="campo in campos" :editor-options="campo.options[0]" v-bind:key="campo.nm_campo"
                    :data-field="campo.nm_campo" :editor-type="campo.tipo_campo" :template="campo.template">
                    <DxLabel :text="campo.options[0].label" />
                </DxSimpleItem>
            </DxGroupItem>
        </DxForm>
        <div class="box-buttons">
            <DxButton class="DxButton" icon="pulldown" type="success" text="Consultar"
                @click="atualiza_dados()" />
        </div>
        <DxDataGrid class="DxDataGrids" @exporting="onExporting"
            :data-source="dados_grid" :key-expr="tela.nm_chave_grid" :selection="{ mode: 'single' }"
            :columns="campos_grid" :show-borders="true" :focused-row-enabled="true" :row-alternation-enabled="true"
            :column-auto-width="true" @selection-changed="onChange_linha">
            <DxRemoteOperations :group-paging="true" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="true" />
            <DxScrolling column-rendering-mode="virtual" />
            <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
            <DxPaging :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />
            <DxExport :enabled="true" :allow-export-selected-data="true">
            </DxExport>
            <template #img="{ data }">
                <button class="imgbutton" @click="OpenImage(data.value)"><img :src="data.value" max-width="130"
                        height="45" alt=""></button>
            </template>
        </DxDataGrid>
    </div>
</template>
<script>
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
} from 'devextreme-vue/form';
import {
    DxDataGrid,
    DxRemoteOperations,
    DxGroupPanel,
    DxGrouping,
    DxSearchPanel,
    DxPaging,
    DxScrolling,
    DxExport,
    DxFilterRow,
    DxHeaderFilter
} from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import api from '../api/api';
export default{
    data(){
        return{
            camposo_grid: [],
            dados_grid: [],
            dados_select: [],
            campo_select: {},
            tela: {},
            campos: [],
            formData: {},
        }
    },
    created(){
        this.carrega_dados()
        this.carrega_tela()
    },
    methods:{
        async carrega_dados(){
            this.dados_grid = await api.get(this.tela.nm_caminho_consulta, [])
        },
        async atualiza_dados(){
            this.dados_grid = await api.get(this.tela.nm_caminho_consulta, [this.formData[this.tela.nm_chave_grid]])
        },
        async carrega_tela(){
            this.tela = JSON.parse(localStorage.getItem("tela"))
            if (localStorage.getItem("campos") == undefined) {
                this.campos = []
            }
            else{
                var campos_c = JSON.parse(localStorage.getItem("campos"))
                campos_c.sort(function (a, b) {
                    console.log(a)
                    if (a.ordem > b.ordem) {
                        return 1
                    }
                    if (a.ordem < b.ordem) {
                        return -1
                    }
                    return 0
                })
                const promise = campos_c.map(async (element_campo) => {
                    if (element_campo.tipo_campo == 'dxSelectBox' || element_campo.tipo_campo == 'DxTagBox') {
                        var parametro = element_campo.options[0].nm_parametro_api
                        if (parametro == undefined) {
                            element_campo.options[0].items = await api.get(element_campo.options[0].nm_api, [])
                        }
                        else {
                            element_campo.options[0].items = await api.get(element_campo.options[0].nm_api, [parametro])
                        }
                    }
                    console.log(element_campo)
                })
                await Promise.all(promise)
                this.campos = campos_c.filter(c => c.show_tela == 'S')
                if (localStorage.getItem("campos_grid") == 'undefined' || localStorage.getItem("campos_grid") == undefined) {
                    this.campos_grid = []
                }
                else {
                    console.log('CARREGOU')
                    this.campos_grid = JSON.parse(localStorage.getItem("campos_grid"))
                    console.log(this.campos_grid)
                }
            }
        }
    },
    components:{
        DxForm,
        DxSimpleItem,
        DxGroupItem,
        DxLabel,
        DxDataGrid,
        DxRemoteOperations,
        DxGroupPanel,
        DxGrouping,
        DxSearchPanel,
        DxPaging,
        DxScrolling,
        DxExport,
        DxFilterRow,
        DxHeaderFilter,
        DxButton
    },
}
</script>